import React from 'react';
import { branch, compose, renderNothing } from 'recompose';
import { isHtml } from 'js/utils/DOM.util';
import { sanitize } from 'dompurify';
import { ReadMore } from 'js/components/common/ReadMore';
import style from './index.scss';

export const RaceRules = ({ className = '', raceRules, lines = 14000 }) => {
    const isHtmlRules = isHtml(raceRules);
    const contentClassName = !isHtmlRules ? style.content : '';
    const html = () => ({ __html: sanitize(raceRules) });

    return (
        <div className={`${style.container} ${className}`}>
            <ReadMore lines={lines} className={contentClassName} buttonClassName={style.button}>
                {isHtmlRules ? <span dangerouslySetInnerHTML={html()} /> : raceRules}
            </ReadMore>
        </div>
    );
};

export default compose(
    branch(
        ({ raceRules }) => !raceRules,
        renderNothing
    )
)(RaceRules);
